import type { SVGProps } from "react";

export const Covertree = ({ viewBox, height, width }: SVGProps<SVGElement>) => (
  <svg
    width={width ?? "240"}
    height={height ?? "226"}
    viewBox={viewBox ?? "0 0 240 226"}
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.90625 192.983L39.5459 142.484H14.3758L109.916 17.6023L205.448 142.484H180.286L218.918 192.983V0H0.90625V192.983Z"
      fill="#007E6A"
    />
    <path
      d="M0 211.825C0 204.305 5.83839 198.617 13.5568 198.617C20.5851 198.617 26.0744 203.369 26.9629 209.897H20.2836C19.4904 206.93 16.8726 204.852 13.5568 204.852C9.59844 204.852 6.63165 207.867 6.63165 211.825C6.63165 215.783 9.59844 218.798 13.5568 218.798C16.8726 218.798 19.4904 216.719 20.2836 213.752H26.9629C26.0744 220.281 20.5851 225.033 13.5568 225.033C5.83839 225.033 0 219.345 0 211.825Z"
      fill="#007E6A"
    />
    <path
      d="M28.8857 211.825C28.8857 204.305 34.7241 198.617 42.4425 198.617C50.161 198.617 55.9993 204.305 55.9993 211.825C55.9993 219.345 50.161 225.033 42.4425 225.033C34.7241 225.033 28.8857 219.345 28.8857 211.825ZM49.3677 211.825C49.3677 207.867 46.4485 204.852 42.4425 204.852C38.4366 204.852 35.5174 207.867 35.5174 211.825C35.5174 215.783 38.4842 218.798 42.4425 218.798C46.4009 218.798 49.3677 215.783 49.3677 211.825Z"
      fill="#007E6A"
    />
    <path
      d="M83.0117 199.211L72.5248 224.444H65.8455L55.4062 199.211H62.728L69.2566 216.377L75.7851 199.211H83.0117Z"
      fill="#007E6A"
    />
    <path
      d="M109.29 214.054H89.2526C90.0934 217.266 92.6636 219.345 96.027 219.345C98.7955 219.345 101.12 218.06 102.111 216.33H108.989C107.156 221.479 102.159 225.04 95.9318 225.04C88.2134 225.04 82.375 219.353 82.375 211.833C82.375 204.313 88.2134 198.625 95.9318 198.625C103.65 198.625 109.489 204.313 109.489 211.88C109.489 212.523 109.441 213.467 109.29 214.054ZM89.3477 209.35H102.556C101.715 206.28 99.089 204.257 95.9239 204.257C92.7588 204.257 90.1886 206.288 89.3477 209.35Z"
      fill="#007E6A"
    />
    <path
      d="M126.793 198.813V205.444C122.041 205.444 119.424 208.165 119.424 212.417V224.435H112.99V199.201H119.424V202.914C121.256 200.344 123.826 198.805 126.793 198.805V198.813Z"
      fill="#007E6A"
    />
    <path
      d="M144.852 205.1H139.76V224.439H133.326V205.1H128.479V199.214H133.326V193.177L139.76 191.789V199.206H144.852V205.092V205.1Z"
      fill="#007E6A"
    />
    <path
      d="M161.73 198.813V205.444C156.979 205.444 154.361 208.165 154.361 212.417V224.435H147.928V199.201H154.361V202.914C156.193 200.344 158.764 198.805 161.73 198.805V198.813Z"
      fill="#007E6A"
    />
    <path
      d="M189.332 214.054H169.295C170.135 217.266 172.706 219.345 176.069 219.345C178.837 219.345 181.162 218.06 182.153 216.33H189.031C187.198 221.479 182.201 225.04 175.974 225.04C168.255 225.04 162.417 219.353 162.417 211.833C162.417 204.313 168.255 198.625 175.974 198.625C183.692 198.625 189.531 204.313 189.531 211.88C189.531 212.523 189.483 213.467 189.332 214.054ZM169.39 209.35H182.598C181.757 206.28 179.131 204.257 175.966 204.257C172.801 204.257 170.231 206.288 169.39 209.35Z"
      fill="#007E6A"
    />
    <path
      d="M218.426 214.054H198.388C199.229 217.266 201.799 219.345 205.163 219.345C207.931 219.345 210.255 218.06 211.247 216.33H218.125C216.292 221.479 211.295 225.04 205.068 225.04C197.349 225.04 191.511 219.353 191.511 211.833C191.511 204.313 197.349 198.625 205.068 198.625C212.786 198.625 218.624 204.313 218.624 211.88C218.624 212.523 218.577 213.467 218.426 214.054ZM198.491 209.35H211.699C210.858 206.28 208.233 204.257 205.068 204.257C201.902 204.257 199.332 206.288 198.491 209.35Z"
      fill="#007E6A"
    />
    <path
      d="M240 215.492C240 220.497 236.208 224.241 231.251 224.241C226.293 224.241 222.501 220.497 222.501 215.492C222.501 210.486 226.245 206.742 231.251 206.742C236.256 206.742 240 210.486 240 215.492ZM238.636 215.492C238.636 211.216 235.431 208.003 231.243 208.003C227.054 208.003 223.85 211.216 223.85 215.492C223.85 219.767 227.007 222.932 231.243 222.932C235.479 222.932 238.636 219.72 238.636 215.492ZM231.877 216.023L234.844 219.863H233.384L230.418 216.023H230.124V219.863H228.911V210.383H231.735C233.337 210.383 234.606 211.644 234.606 213.207C234.606 214.77 233.44 215.976 231.885 216.031L231.877 216.023ZM230.132 214.952H231.687C232.663 214.952 233.392 214.223 233.392 213.199C233.392 212.176 232.663 211.494 231.687 211.494H230.132V214.944V214.952Z"
      fill="#007E6A"
    />
  </svg>
);
